var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInterfaceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2896_24524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 7C1 3.13401 4.13401 0 8 0H42C45.866 0 49 3.13401 49 7V41C49 44.866 45.866 48 42 48H8C4.13401 48 1 44.866 1 41V7Z",
    fill: "#FEF9E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.325 23.5C23.775 23.5 23.3042 23.3042 22.9125 22.9125C22.5208 22.5208 22.325 22.05 22.325 21.5V19C22.325 18.45 22.5208 17.9792 22.9125 17.5875C23.3042 17.1958 23.775 17 24.325 17H32C32.55 17 33.0208 17.1958 33.4125 17.5875C33.8042 17.9792 34 18.45 34 19V21.5C34 22.05 33.8042 22.5208 33.4125 22.9125C33.0208 23.3042 32.55 23.5 32 23.5H24.325ZM30.675 31C30.125 31 29.6542 30.8042 29.2625 30.4125C28.8708 30.0208 28.675 29.55 28.675 29V26.5C28.675 25.95 28.8708 25.4792 29.2625 25.0875C29.6542 24.6958 30.125 24.5 30.675 24.5H32C32.55 24.5 33.0208 24.6958 33.4125 25.0875C33.8042 25.4792 34 25.95 34 26.5V29C34 29.55 33.8042 30.0208 33.4125 30.4125C33.0208 30.8042 32.55 31 32 31H30.675ZM24.325 31C23.775 31 23.3042 30.8042 22.9125 30.4125C22.5208 30.0208 22.325 29.55 22.325 29V26.5C22.325 25.95 22.5208 25.4792 22.9125 25.0875C23.3042 24.6958 23.775 24.5 24.325 24.5H25.675C26.225 24.5 26.6958 24.6958 27.0875 25.0875C27.4792 25.4792 27.675 25.95 27.675 26.5V29C27.675 29.55 27.4792 30.0208 27.0875 30.4125C26.6958 30.8042 26.225 31 25.675 31H24.325ZM18 31C17.45 31 16.9792 30.8042 16.5875 30.4125C16.1958 30.0208 16 29.55 16 29V19C16 18.45 16.1958 17.9792 16.5875 17.5875C16.9792 17.1958 17.45 17 18 17H19.325C19.875 17 20.3458 17.1958 20.7375 17.5875C21.1292 17.9792 21.325 18.45 21.325 19V29C21.325 29.55 21.1292 30.0208 20.7375 30.4125C20.3458 30.8042 19.875 31 19.325 31H18Z",
    fill: "#D8AD09"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2896_24524",
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2896_24524"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2896_24524",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterfaceIcon);
export default __webpack_public_path__ + "static/media/interface-icon.650c67d8d5821f7d8525cf7a10ff83f3.svg";
export { ForwardRef as ReactComponent };